module.exports = __webpack_public_path__ + "files/3d198a881d2dabfa14f618806ac68c3a.png";